import { render } from "./AddProgram.vue?vue&type=template&id=cd63fbba"
import script from "./AddProgram.vue?vue&type=script&lang=js"
export * from "./AddProgram.vue?vue&type=script&lang=js"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__